type Variant = "default" | "secondary" | "destructive" | "outline";

// Compra pendente é cancelada pelo pg_cron limpar_compras_expiradas após 24 h sem pagamento: não é falha de PIX.
const STATUS: Record<string, { label: string; variant: Variant }> = {
  pago: { label: "Processado", variant: "default" },
  processando: { label: "Processando", variant: "outline" },
  pendente: { label: "Aguardando pagamento", variant: "outline" },
  cancelado: { label: "Expirada sem pagamento", variant: "secondary" },
  falhou: { label: "Falhou", variant: "destructive" },
};

export const statusCompra = (status: string) => STATUS[status] ?? { label: status, variant: "outline" as Variant };

type CompraDoParceiro = { empresa_id: string; empresa_nome: string };

export function parceirosDasCompras(compras: CompraDoParceiro[] | undefined): { id: string; nome: string }[] {
  const porId = new Map((compras ?? []).map((c) => [c.empresa_id, c.empresa_nome]));
  return Array.from(porId, ([id, nome]) => ({ id, nome })).sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
}

export function filtrarPorParceiro<T extends CompraDoParceiro>(compras: T[] | undefined, parceiroId: string): T[] {
  return (compras ?? []).filter((c) => parceiroId === "all" || c.empresa_id === parceiroId);
}
